export const FALLBACK_IMG = "/default-placeholder.png";
